class HttpStatus {
  statusCode: number;

  reasonPhrase: string;

  constructor(statusCode: number, reasonPhrase: string) {
    this.statusCode = statusCode;
    this.reasonPhrase = reasonPhrase;
  }

  // eslint-disable-next-line @typescript-eslint/explicit-function-return-type
  getStatusCode() {
    return this.statusCode;
  }

  // eslint-disable-next-line @typescript-eslint/explicit-function-return-type
  getReasonPhrase() {
    return this.reasonPhrase;
  }
}

const OK = new HttpStatus(200, 'OK');
const CREATED = new HttpStatus(201, 'Created');
const NO_CONTENT = new HttpStatus(204, 'No Content');
const BAD_REQUEST = new HttpStatus(400, 'Bad Request');
const UNAUTHORIZED = new HttpStatus(401, 'Unauthorized');
const FORBIDDEN = new HttpStatus(403, 'Forbidden');
const NOT_FOUND = new HttpStatus(404, 'Not Found');
const CONFLICT = new HttpStatus(409, 'Conflict');
const PRECONDITION_FAILED = new HttpStatus(412, 'Precondition Failed');
const AUTHENTICATION_TIMEOUT = new HttpStatus(419, 'Authentication Timeout');
const UNPROCESSABLE_ENTITY = new HttpStatus(422, 'Unprocessable Entity');
const TOO_MANY_REQUESTS = new HttpStatus(429, 'Too Many Requests');
const INTERNAL_SERVER_ERROR = new HttpStatus(500, 'Internal Server Error');
const BAD_GATEWAY = new HttpStatus(502, 'Bad Gateway');
const SERVICE_UNAVAILABLE = new HttpStatus(503, 'Service Unavailable');
const GATEWAY_TIMEOUT = new HttpStatus(504, 'Gateway Timeout');
const INVALID_RESPONSE = new HttpStatus(0, 'Invalid Response');

export const HTTP_STATUS = Object.freeze({
  OK,
  200: OK,
  CREATED,
  201: CREATED,
  NO_CONTENT,
  204: NO_CONTENT,
  BAD_REQUEST,
  400: BAD_REQUEST,
  UNAUTHORIZED,
  401: UNAUTHORIZED,
  FORBIDDEN,
  403: FORBIDDEN,
  NOT_FOUND,
  404: NOT_FOUND,
  CONFLICT,
  409: CONFLICT,
  PRECONDITION_FAILED,
  412: PRECONDITION_FAILED,
  AUTHENTICATION_TIMEOUT,
  419: AUTHENTICATION_TIMEOUT,
  UNPROCESSABLE_ENTITY,
  422: UNPROCESSABLE_ENTITY,
  TOO_MANY_REQUESTS,
  429: TOO_MANY_REQUESTS,
  INTERNAL_SERVER_ERROR,
  500: INTERNAL_SERVER_ERROR,
  BAD_GATEWAY,
  502: BAD_GATEWAY,
  SERVICE_UNAVAILABLE,
  503: SERVICE_UNAVAILABLE,
  GATEWAY_TIMEOUT,
  504: GATEWAY_TIMEOUT,
  INVALID_RESPONSE,
  0: INVALID_RESPONSE,
});

export const VALID_STATUSES = [
  HTTP_STATUS.OK.getStatusCode(),
  HTTP_STATUS.CREATED.getStatusCode(),
  HTTP_STATUS.NO_CONTENT.getStatusCode(),
];

export const LOG_SKIPPED_STATUSES = [
  HTTP_STATUS.CONFLICT.getStatusCode(),
  HTTP_STATUS.UNPROCESSABLE_ENTITY.getStatusCode(),
  HTTP_STATUS.NOT_FOUND.getStatusCode(),
  HTTP_STATUS.INVALID_RESPONSE.getStatusCode(),
];

export const INTERCEPTOR_HANDLED_STATUSES = [
  HTTP_STATUS.BAD_REQUEST.getStatusCode(),
  HTTP_STATUS.UNAUTHORIZED.getStatusCode(),
  HTTP_STATUS.FORBIDDEN.getStatusCode(),
  HTTP_STATUS.AUTHENTICATION_TIMEOUT.getStatusCode(),
  HTTP_STATUS.INTERNAL_SERVER_ERROR.getStatusCode(),
  HTTP_STATUS.BAD_GATEWAY.getStatusCode(),
  HTTP_STATUS.SERVICE_UNAVAILABLE.getStatusCode(),
  HTTP_STATUS.GATEWAY_TIMEOUT.getStatusCode(),
];
